import { render, staticRenderFns } from "./NewInviteNotification.vue?vue&type=template&id=b6f033c4&scoped=true&"
import script from "./NewInviteNotification.vue?vue&type=script&lang=js&"
export * from "./NewInviteNotification.vue?vue&type=script&lang=js&"
import style0 from "./NewInviteNotification.vue?vue&type=style&index=0&id=b6f033c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f033c4",
  null
  
)

export default component.exports